import { DeleteTwoTone, EditTwoTone, PlusOutlined } from "@ant-design/icons";
import {
  PageHeader,
  Row,
  Col,
  Tooltip,
  Button,
  Tag,
  notification,
} from "antd";
import { useEffect, useState } from "react";

import IconMaster from "../../static/icon/IconMaster";
import IconPointSetup from "../../static/icon/IconPointSetup";
import ActionModal from "./ActionModal";
import { useAuth } from "../../context/auth";
import { formatDateTime } from "../../utils/formatter";
import DeleteAction from "../../Tools/DeleteAction";

const PointSetupComponent = () => {
  const { accessToken } = useAuth();

  const [modalType, setModalType] = useState(null);
  const [currentPoint, setCurrentPoint] = useState(null);
  const [points, setPoints] = useState([]);
  const [update, setUpdate] = useState(0);

  useEffect(() => {
    async function getPoints() {
      const url = new URL('/api/point', window.location);

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      });
      if (res.ok) {
        const { points } = await res.json();
        setPoints(points);
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    };

    getPoints();
  }, [accessToken, update]);

  return (
    <>
      <div className="flex justify-between items-center mt-2">
        <PageHeader
          style={{ padding: 0, width: "100%" }}
          title={
            <span className="flex items-center mt-2">
              <IconMaster /> &nbsp;&nbsp;Point Setup
            </span>
          }
        />

        <Button
          className="mt-2 flex items-center"
          icon={<PlusOutlined />}
          type="primary"
          shape="round"
          onClick={() => {
            setModalType("new");
            setCurrentPoint({});
          }}
        >
          New Point Setup
        </Button>
      </div>

      {points.map((point, i) => (
        <Row key={point.id}>
          <Col span={24}>
            <div
              className="content mx-2"
              style={{ borderLeft: i === 0 ? "10px solid #55B491" : "10px solid #FFAC1F" }}
            >
              <Row>
                <Col span={11}>
                  <Row>
                    <Col span={i === 0 ? 7 : 0}>
                      <IconPointSetup />
                    </Col>
                    <Col span={17}>
                      <Row
                        className="mx-2"
                        style={{ fontWeight: 600, fontSize: 20 }}
                      >
                        <span>Redeem Green Point</span>
                      </Row>
                      <Row
                        className="mt-2 mx-2"
                        style={{ fontWeight: 400, fontSize: 16 }}
                      >
                        <span>
                          Effective Date {formatDateTime(new Date(point.validFrom))}
                        </span>
                      </Row>
                      <Row
                        className="mt-2 mx-2"
                        style={{ fontWeight: 400, fontSize: 16 }}
                      >
                        <div>
                          {i === 0 ? (
                            <Tag color="green">Active</Tag>
                          ) : (
                            <Tag color="orange">Pending</Tag>
                          )}
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={6}
                  style={{ backgroundColor: "#F6F7F7", marginRight: 20 }}
                >
                  <Row style={{ paddingLeft: 10, paddingTop: 10 }}>
                    <span className="flex gap-1 font-bold text-2xl">
                      <span>
                        {point.fromBaht} THB
                      </span>
                      <span>
                        =
                      </span>
                      <span style={{ color: "#3699FF" }}>
                        {point.toPoint} Point
                      </span>
                    </span>
                  </Row>
                  <Row className="mt-2" style={{ paddingLeft: 10 }}>
                    <span style={{ fontWeight: 400, fontSize: 16 }}                    >
                      Rate to earn Green Point
                    </span>
                  </Row>
                </Col>
                <Col span={5} style={{ backgroundColor: "#F6F7F7" }}>
                  <Row style={{ paddingLeft: 10, paddingTop: 10 }}>
                    <Col span={23}>
                      <span className="flex gap-1 font-bold text-2xl">
                        <span>
                          {point.fromPoint} Point
                        </span>
                        <span>
                          =
                        </span>
                        <span style={{ color: "#80CB8E" }}>
                          {point.toBaht} THB
                        </span>
                      </span>
                    </Col>
                  </Row>
                  <Row className="mt-2" style={{ paddingLeft: 10 }}>
                    <span style={{ fontWeight: 400, fontSize: 16 }}>
                      Rate to use Green Point
                    </span>
                  </Row>
                </Col>
                <Col span={i === 0 ? 0 : 1} style={{ marginLeft: 5 }}>
                  <div class="flex gap-1">
                    <Tooltip placement="bottom" title="Edit">
                      <EditTwoTone
                        style={{
                          backgroundColor: "#F3F6F9",
                          padding: 6,
                          borderRadius: 6,
                        }}
                        onClick={() => {
                          setModalType("edit");
                          setCurrentPoint(point);
                        }}
                      />
                    </Tooltip>
                    <Tooltip placement="bottom" title="Delete">
                      <DeleteTwoTone
                        style={{
                          backgroundColor: "#F3F6F9",
                          padding: 6,
                          borderRadius: 6,
                        }}
                        onClick={() => {
                          setModalType("delete");
                          setCurrentPoint(point);
                        }}
                        twoToneColor="red"
                      />
                    </Tooltip>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      ))}

      <ActionModal
        visible={modalType !== 'delete' && currentPoint}
        modalType={modalType}
        editRecord={currentPoint}
        onCancel={() => setCurrentPoint(null)}
        onOk={() => {
          setCurrentPoint(null);
          setUpdate(update => update + 1);
        }}
      />
      <DeleteAction
        openModalActionDelete={modalType === 'delete' && currentPoint}
        name="Point"
        type="point"
        editRecord={currentPoint}
        onCancel={() => setCurrentPoint(null)}
        onOk={() => {
          setCurrentPoint(null);
          setUpdate(update => update + 1);
        }}
      />
    </>
  );
};

export default PointSetupComponent;
